import React from 'react'
import { Stack } from 'react-bootstrap'
import type { ReactNode } from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { useDashboardContext } from './Context'

export type WidgetContainerProps = { height: number; children: React.ReactNode; title?: ReactNode }

export const WidgetContainer = ({ height, children, title }: WidgetContainerProps) => {
  const { setting } = useDashboardContext()

  // A locked grid item hides its toolbar row, which hands its 20px to the widget.
  const finalHeight = !setting.isLocked ? height - 50 : height + 20 - 50

  return (
    <Stack gap={2} style={{ height: finalHeight }} className="justify-content-start overflow-auto">
      <ShowIf condition={!!title}>
        <h4>{title}</h4>
      </ShowIf>

      <div>{children}</div>
    </Stack>
  )
}
